import $ from 'jquery';

export default class Nav {
  constructor() {
    this.model = {
      isActive: false,
    }
    this.init();
  }


  init() {
    this.bindEvents();
  }


  bindEvents() {
    $('#js-ham').on('click', () => {
      this.onClickHam();
    }, );
  }
  onClickHam() {
    if(this.model.isActive) {
      $('.l-header__ham').removeClass('is-active');
      $(window).off('.noScroll');
    } else {
      $('.l-header__ham').addClass('is-active');
      $(window).on('touchmove.noScroll', function(e) {
        e.preventDefault();
      },);
    }
    $('.l-header__list--outer').slideToggle('fast');
    this.model.isActive = this.model.isActive ? false : true;
  }
}


// WEBPACK FOOTER //
// ./dev/js/nav.js